import { Action } from '@ngrx/store';
import {
  DxWindowSettings
} from '../windows/window-config';

export class OpenComponentInWindow<D> implements Action {
  public static TYPE = '@digitaix/core/component/OPEN_COMPONENT_IN_WINDOW';
  public readonly type = OpenComponentInWindow.TYPE;

  constructor(
    public componentId: string,
    public data: D,
    public tracer: string,
    public config: Partial<DxWindowSettings> = {},
    public stack?: string[]
  ) {
    if (!this.config.id) {
      this.config.id = componentId + (data ? JSON.stringify(data).length.toFixed(0) : '' );
    }
  }
}

export class OpenComponentInWindowWithDocumentId implements Action {
  public static TYPE = '@digitaix/core/component/OPEN_COMPONENT_IN_WINDOW_WITH_DOCUMENT_ID';
  public readonly type = OpenComponentInWindowWithDocumentId.TYPE;

  constructor(
    public componentId: string,
    public documentId: string,
    public collectionPath: string,
    public tracer: string,
    public config: Partial<DxWindowSettings> = {},
    public stack?: string[]
  ) {
    if (!this.config.id) {
      this.config.id = [componentId, collectionPath, componentId].join('-');
    }
  }
}
